import React from 'react';
import classNames from 'classnames';
import { oneOf } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Image } from '@thd-olt-component-react/core-ui';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';
import styles from './virtual-assistance.scss';

let cx = classNames.bind(styles);

const VirtualAssistanceTooltip = React.forwardRef(({ channel }, buttonRef) => {

  const toolTipLabelClasses = classNames('&__request-appointment-tooltip', {
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    scrollTouch: channel === 'mobile',
  });

  const tooltipContent = (
    <div className={cx('va-tooltip')}>
      <div className={cx('va-tooltip__ul')}>
        <p className={cx('va-tooltip__title')}>HOW IT WORKS</p>
        <p>What can we help you with?</p>
        <ul className={cx('va-tooltip__list', 'va-tooltip__sublist')}>
          <li>Available styles</li>
          <li>How to measure</li>
          <li>Custom door/window designs</li>
          <li>Pro orders</li>
          <li>Installation</li>
        </ul>
      </div>
      <ol className={cx('va-tooltip__list', 'va-tooltip__ol')}>
        <li>
          <p className={cx('va-tooltip__title')}>Request a free virtual appointment</p>
          <p>
            Request a free virtual appointment to schedule a time to speak with a door and window
            associate or call 1-833-HDAPRON (432-7766) from 9 a.m. to 8 p.m. EST, 7 days/week.
          </p>
        </li>
        <li>
          <p className={cx('va-tooltip__title')}>Speak with an associate</p>
          <p>
            How can we help? Whether you have questions about product availability or features or need
            a quote for a custom door or window solution, we&apos;ve got you covered.
          </p>
        </li>
        <li>
          <p className={cx('va-tooltip__title')}>We&apos;ll follow up</p>
          <p>We&apos;ll make sure you have everything you need for your project!</p>
        </li>
      </ol>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" className={toolTipLabelClasses} ref={buttonRef}>
        <Image
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className={cx('product-add-on-tooltip-content__label__suffix')}
          width="1"
          height="1"
        />
        What to Expect
      </button>
    </Tooltip>
  );
});

VirtualAssistanceTooltip.displayName = 'ProductAddOns-virtual-assistance-tooltip';

VirtualAssistanceTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
};

VirtualAssistanceTooltip.defaultProps = {
  channel: 'desktop',
};

export { VirtualAssistanceTooltip };